import { render } from "./title-layer.vue?vue&type=template&id=0208809a"
import script from "./title-layer.vue?vue&type=script&lang=js"
export * from "./title-layer.vue?vue&type=script&lang=js"

import "./title-layer.vue?vue&type=style&index=0&id=0208809a&lang=less"

import exportComponent from "/Users/liuyansong/Work/Vue/test/vue3-video-player/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__